var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-title"},[_c('div',{staticClass:"level mb-32px"},[_c('div',{staticClass:"level-left"},[_c('h1',{staticClass:"has-text-weight-bold is-2 is-marginless title"},[_vm._t("default")],2)]),_c('div',{staticClass:"level-right is-hidden-print"},[_vm._t("actions")],2)]),_c('div',{staticClass:"content has-max-width-768",class:{
      'mb-24px': _vm.$media.mobile,
      'mb-32px': _vm.$media.tablet,
      'mb-40px': _vm.$media.widescreen
    }},[_vm._t("description")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }